<template>
    <div class="m-ifund-mask">
        <section id="poster-content" v-if="initAllMeList && initAllMeList.length > 0">
            <share id="real-content" :initAllMeList="initAllMeList"></share>
        </section>
        <section class="m-share-bottom">
            <div class="m-share-base m-share-icon1">
                <ul>
                    <li v-for="second in secondArr" :key="second.name" @click="clickShare(second.type)">
                        <img :src="second.icon" alt="#">
                        <span>{{second.text}}</span>
                    </li>
                </ul>
            </div>
            <div class="m-share-btn" @click="cancel">取消</div>
        </section>
    </div>
</template>

<script>
    import Share from './share';
    import icon_pengyouquan from "@/assets/images/i-share_pyq.png";
    import icon_weixin from "@/assets/images/i-share_wechat.png";
    import icon_qq from "@/assets/images/i-share_qq.png";
    import icon_qqkj from "@/assets/images/i-share_qqkj.png";
    import icon_weibo from "@/assets/images/i-share_weibo.png";
    import icon_save from "@/assets/images/i-share_save.png";
    import html2canvas from "html2canvas";
    import { startShare } from '@/assets/js/fn.js';
    import { reportError } from '@/utils/monitor.js'
    export default {
        name: "fundMask",
        components: {
            Share
        },
        props: {
            initAllMeList: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                secondArr: [
                    { text: "保存图片", icon: icon_save, type: "0" },
                    { text: "微信", icon: icon_weixin, type: "1" },
                    { text: "朋友圈",icon: icon_pengyouquan,type: "2" },
                    { text: "QQ", icon: icon_qq, type: "3" },
                ],
            }
        },
        methods: {
            cancel() {
                this.$emit('changeFirst', false);
            },
            clickShare: function(type) {
                const _this = this;
                let _copyDom = document.getElementById("real-content");
                _.fundLoading();
                html2canvas(_copyDom, {
                    height: _copyDom.offsetHeight,
                    useCORS: true,
                    backgroundColor: "#FFFFFF"
                }).then(function(canvas) {
                    _.hideFundLoading();
                    let _url = canvas.toDataURL();
                    if (type === '0') {
                        let _url1 = _url.split(",")[1];
                        if (_.urlInfo.sys === 'ijijin') {
                            callNativeHandler("saveImage", { imageStr: _url1 }, data => {
                                if (_.platform.osInfo === "iphone") {
                                    if (data == "OK" || data == "ok") {
                                        _this.$toast("已保存到您的相册");
                                    } else {
                                        _this.$toast("保存失败，请重试");
                                    }
                                }
                            });
                        } else {
                            callNativeHandler('notifyWebHandleEvent', { 
                                method: 'saveImageToAlbum', 
                                params: {
                                    source: 'data',
                                    image: _url1,
                                    succeedToast: '已保存到您的相册',//成功文案
                                    failedToast: '保存失败，请重试'//失败文案
                                } 
                            }, function() {
                            });
                        }
                        
                    } else {
                        startShare(_url, type, '估值分享', '估值分享排行榜');
                    }
                    _this.$emit('changeInitshare');
                    
                }).catch((e) => {
                    reportError('js', 'error html2canvas promise', e);
                    _.hideFundLoading();
                })
            }
        },
        mounted() {
            const _this = this;
            if (_.urlInfo.sys === 'ths') {
                _this.secondArr.push({ text: "微博", icon: icon_weibo, type: "5"});
                if (_.platform.osInfo === 'gphone') {
                    // 安卓手抄不能下载图片
                    _this.secondArr.push({ text: "QQ空间", icon: icon_qqkj, type: "4"});
                    _this.secondArr.splice(0, 1);
                }
            } else {
                _this.secondArr.push({ text: "QQ空间", icon: icon_qqkj, type: "4"});
            }
            _this.$emit('changeInitshare');
        }
    }
</script>

<style lang="less">
.m-ifund-mask {
    position: fixed;
    z-index: 10;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.45);
    #poster-content {
        margin: 80px 64px 408px;
        height: calc(100vh - 408px - 80px);
        overflow-y: auto;
    }
    .m-share-bottom {
        box-sizing: border-box;
        position: absolute;
        padding: 0 32px 32px;
        width: 100%;
        bottom: 0;
        background: #F6F6F6;
        border-radius: 24px 24px 0 0;
        .m-share-base {
            ul {
                overflow-y: auto;
                white-space: nowrap;
                &:first-child {
                    margin-top: 72px;
                }
                margin-bottom: 72px;
                li {
                    box-sizing: border-box;
                    display: inline-block;
                    padding-top: 20px;
                    width: 144px;
                    height: 144px;
                    background: #FFFFFF;
                    border-radius: 32px;
                    margin-right: 24px;
                    img {
                        display: block;
                        width: 64px;
                        height: 64px;
                        margin: 0 auto 6px;
                    }
                    span {
                        display: block;
                        font-family: PingFangSC-Regular;
                        font-size: 22px;
                        color: #323232;
                        text-align: center;
                        font-weight: 400;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }
        .m-share-btn {
            height: 88px;
            background: #FFFFFF;
            border-radius: 16px;
            font-family: PingFangSC-Regular;
            font-size: 32px;
            color: #323232;
            text-align: center;
            font-weight: 400;
            line-height: 88px;
        }
    }
}
</style>